import request from '../request'

export default {
  getOrganismos() {
    return request.get('organismo')
  }
}
